module.exports = __webpack_public_path__ + "175a6f46ed2e2c8c8f29a217a2d604f4.jpg";